module.exports = __webpack_public_path__ + "img/buettner_mpp_260.53484e40.png";